import { Component } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleExclamation, faExclamation, IconDefinition } from '@fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'fdx-invalid-avatar',
    templateUrl: './invalid-avatar.component.html',
    styleUrls: ['../user-avatar.scss', './invalid-avatar.component.scss'],
    imports: [
        FaIconComponent
    ],
    standalone: true
})
export class InvalidAvatarComponent {
    readonly exclamationIcon: IconDefinition = faExclamation;
    readonly danger: IconDefinition = faCircleExclamation;
}
